import _extends from "@babel/runtime-corejs2/helpers/esm/extends";
import _classCallCheck from "@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime-corejs2/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs2/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime-corejs2/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime-corejs2/helpers/esm/inherits";
import _defineProperty from "@babel/runtime-corejs2/helpers/esm/defineProperty";
import React, { Component } from "react";
import isEmpty from "lodash/isEmpty";
import { NativeFeaturesProvider, NativeFeaturesConsumer } from "@origin-digital/native-features";
import { NBAComponentType } from "./nextbestaction.types";
import { getInititalShowState, handleHide, generateDismissMessage, undoHide, shouldUseEventDispatch, isRequiredFeatureAvailable } from "./NextBestAction.utils";
import { CollapsibleNBA } from "./variants/CollapsibleNBA";
import { ExperimentCardNBA } from "./variants/ExperimentCardNBA";
import { CardNBA } from "./variants/CardNBA";
import { DismissMessage } from "./components/DismissMessage";
export var NextBestAction =
/*#__PURE__*/
function (_Component) {
  _inherits(NextBestAction, _Component);

  function NextBestAction() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, NextBestAction);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(NextBestAction)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      show: true,
      showDismissMessage: false
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidUpdate", function (prevProps) {
      if (prevProps.content !== _this.props.content) {
        var show = getInititalShowState(new Date(), _this.props.content);

        _this.setState({
          show: show
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "setShowDismissMessage", function (showDismissMessage) {
      _this.setState({
        showDismissMessage: showDismissMessage
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onHide", function () {
      handleHide(_this.props.content.experienceId, _this.setShowDismissMessage);
    });

    _defineProperty(_assertThisInitialized(_this), "getComponentForType", function () {
      var content = _this.props.content;

      switch (content.componentType) {
        case NBAComponentType.COLLAPSIBLE:
          return CollapsibleNBA;

        case NBAComponentType.EXPERIMENT_CARD:
          return ExperimentCardNBA;

        default:
          return CardNBA;
      }
    });

    return _this;
  }

  _createClass(NextBestAction, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var show = getInititalShowState(new Date(), this.props.content);
      this.setState({
        show: show
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$state = this.state,
          show = _this$state.show,
          showDismissMessage = _this$state.showDismissMessage;
      var content = this.props.content;
      var showCard = !isEmpty(content) && show;

      if (showDismissMessage) {
        return React.createElement(DismissMessage, {
          text: generateDismissMessage(content.dismissDuration),
          undoHide: undoHide(content.experienceId, this.setShowDismissMessage)
        });
      } else if (showCard) {
        var _Component2 = this.getComponentForType();

        var buttonLink = this.props.content.buttonLink;

        if (shouldUseEventDispatch(buttonLink)) {
          return React.createElement(NativeFeaturesProvider, null, React.createElement(NativeFeaturesConsumer, null, function (context) {
            return isRequiredFeatureAvailable(context.features, buttonLink) ? React.createElement(_Component2, _extends({}, _this2.props, {
              onHide: _this2.onHide
            })) : null;
          }));
        } else {
          return React.createElement(_Component2, _extends({}, this.props, {
            onHide: this.onHide
          }));
        }
      }

      return null;
    }
  }]);

  return NextBestAction;
}(Component);